
import React from 'react';
import Videos from '../components/Videos';
import Footer from '../components/Footer';


function VideosPage() {
  return (
    <>
        <Videos />
        <Footer />
    </>
  );
}


export default VideosPage;